"use client";

import { useState } from "react";
import { useTranslations } from "next-intl";
import CampaignTabsSection from "./CampaignTabsSection";
import Image from "next/image";
import { Button } from "./ui/Button";
import { formatDate } from "@/utils/dateFormatter";

const HTML_TAG_REGEX = /<[^>]+>/;
const isHtmlString = (str) =>
  typeof str === "string" && str.trim() && HTML_TAG_REGEX.test(str);
function HtmlOrText({ value, as: Tag = "div", className = "" }) {
  if (value == null || value === "") return null;
  const str = String(value);
  if (isHtmlString(str)) {
    return (
      <Tag className={className} dangerouslySetInnerHTML={{ __html: str }} />
    );
  }
  return <Tag className={className}>{str}</Tag>;
}

export default function AirlinePromotionsTabsContent({
  title,
  airlineName,
  locale,
  tabs,
  promotionsListNew,
  promotionsListOld,
}) {
  const t = useTranslations("flight");
  const [activeTab, setActiveTab] = useState("new");
  const handleTabChange = (tabId) => setActiveTab(tabId);
  const currentList =
    activeTab === "new" ? promotionsListNew : promotionsListOld;
  const ariaLabel =
    activeTab === "new"
      ? t("airlinePromotionsTabNew")
      : t("airlinePromotionsTabOld");
  return (
    <CampaignTabsSection
      title={title}
      showTabs={true}
      tabs={tabs}
      activeTab={activeTab}
      handleTabChange={handleTabChange}
    >
      <div className="mt-4 flex w-full flex-col gap-5 lg:mt-8 lg:gap-18">
        {currentList.map((promotion) => (
          <div
            key={promotion.Id}
            className="flex flex-col gap-6 lg:flex-row lg:gap-8"
          >
            {" "}
            <div className="relative aspect-[80/69] w-full shrink-0 self-start rounded-md lg:w-[188px] xl:w-[294px]">
              <Image
                // src={promotion.ImageUrl || promotion.ImageUrlWithoutBase}
                src={"/images/dummy/blog-dummy-3.jpg"}
                alt={t("airlinePromotionsImageAlt", {
                  airline: airlineName || "",
                })}
                fill
                className="rounded-md object-cover"
              />
            </div>
            <div className="flex flex-col gap-6">
              <div className="flex flex-col gap-4">
                <HtmlOrText
                  value={promotion.Title}
                  as="div"
                  className="text-2xl font-bold"
                />
                <div className="border-border-weak divide-border-weak grid w-full grid-cols-1 divide-y rounded-md border md:grid-cols-2 md:divide-x md:divide-y-0">
                  <div className="flex flex-col items-center justify-center gap-[5px] p-6 text-center">
                    <span className="text-base/[21px] font-normal">
                      {t("airlinePromotionsStartDate")}:
                    </span>
                    <span className="text-base/[21px] font-semibold">
                      {formatDate(promotion.StartDate)}
                    </span>
                  </div>
                  <div className="flex flex-col items-center justify-center gap-[5px] p-6">
                    <span className="text-center text-base/[21px] font-normal">
                      {t("airlinePromotionsEndDate")}:
                    </span>
                    <span className="text-base/[21px] font-semibold">
                      {formatDate(promotion.EndDate, { locale: locale })}
                    </span>
                  </div>
                </div>
                <HtmlOrText value={promotion.Content} />
              </div>
              <div>
                <Button
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                  size="lg"
                >
                  {t("airlinePromotionsBookTicketButton")}
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </CampaignTabsSection>
  );
}
